(function () {
  function getSelectedFinish() {
    // Try to read "Brass" / "Silver" from the currently selected UI
    // 1) pill buttons (common)
    const pressed = document.querySelector('[aria-pressed="true"]');
    const pressedText = (pressed?.textContent || '').trim().toLowerCase();
    if (pressedText === 'brass' || pressedText === 'silver') return pressedText;

    // 2) checked radios + label text
    const checked = document.querySelector('input[type="radio"]:checked');
    if (checked) {
      const label = document.querySelector(`label[for="${checked.id}"]`);
      const txt = (label?.textContent || '').trim().toLowerCase();
      if (txt === 'brass' || txt === 'silver') return txt;
    }

    // 3) select dropdowns
    for (const sel of document.querySelectorAll('select')) {
      const v = (sel.value || '').trim().toLowerCase();
      if (v === 'brass' || v === 'silver') return v;
    }

    return null;
  }

  function filterThumbs(scope) {
    const root = scope || document;
    const finish = getSelectedFinish();
    if (!finish) return;

    // IMPORTANT: gallery gets replaced on variant updates, so always query fresh
    root.querySelectorAll('button.slideshow-controls__thumbnail[data-buckle]').forEach((btn) => {
      const buckle = (btn.getAttribute('data-buckle') || '').toLowerCase();
      btn.style.display = buckle === finish ? '' : 'none';
    });
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', () => filterThumbs(document));

  // Your theme fires a custom variant update event (seen in your MediaGallery code)
  // We can listen for it globally and re-filter after the HTML swap happens.
  document.addEventListener('theme:variant:update', () => setTimeout(() => filterThumbs(document), 0));

  // Fallbacks (covers option clicks/changes even if the custom event name differs somewhere)
  document.addEventListener('change', () => setTimeout(() => filterThumbs(document), 0));
  document.addEventListener('click', () => setTimeout(() => filterThumbs(document), 0));
})();
